// extracted by mini-css-extract-plugin
export default {"eduCertsContainer":"EduAndCerts_eduCertsContainer__UKNPt","certTitle":"EduAndCerts_certTitle__ldcl9"};